import Axios from "axios";
import { parcelTerminalBulder } from "../../helpers/Utils";
export const getParcelTerminalsOption = () => {
  return Axios.get(`/api/v1/parcel_terminals`).then((res) => {
    return parcelTerminalBulder(res.data);
  });
};
